import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { Subscription } from 'rxjs';

import {
    AuthorizationService,
    UserService,
    EquipmentService,
    ModelService,
    PoweredByService,
    PoweredBysByModel,
    EquipmentForModelAndPoweredBy,
    CompanyService,
    MinesiteService,
    DocumentService,
    CompanyMinesites,
    Company,
    Minesite,
    User,
    Equipment,
    Document,
    Model,
    PoweredBy,
    DataArray,
    Permission
} from './../../../shared/index';


@Component({
    selector: 'report-index',
    templateUrl: './report-index.html',
    standalone: false
})

export class ReportIndexComponent implements OnInit, OnDestroy {
    public companies: Company[] = [];
    public minesites: DataArray<Minesite> = new DataArray<Minesite>(1);
    public models: DataArray<Model> = new DataArray<Model>(1);
    public poweredBys: PoweredBy[] = [];
    public equipment: DataArray<Equipment> = new DataArray<Equipment>(1);
    public permissions: Permission[] = [];

    public filteredMinesites: Minesite[] = [];

    public selectedModelId = 0;
    public selectedPoweredByIds: number[] = [];
    public selectedEquipmentIds: number[] = [];
    public selectedCompanies: number[] = [];
    public selectedMinesites: number[] = [];
    public selectedPermissionIds: number[] = [];


    public equipmentReportUlr = '';
    public manualsReportUlr = '';
    public userReportUrl = '';

    private rawEquipmentUrl: string = window.document.location.origin + '/api/Reports/EquipmentReport';
    private rawManualsUrl: string = window.document.location.origin + '/api/Reports/ManualsReport';
    private rawUserUrl: string = window.document.location.origin + '/api/Reports/UserReport';
    private subscriptions: Subscription[] = [];

    constructor(
        private _ngZone: NgZone,
        private _authorizationService: AuthorizationService,
        private _companyService: CompanyService,
        private _minesiteService: MinesiteService,
        private _modelService: ModelService,
        private _poweredByService: PoweredByService,
        private _equipmentService: EquipmentService,
        private _userService: UserService
    ) {
        this.minesites.init();
        this.models.init();

        this.subscriptions.push(this._companyService.companysChange.subscribe((info: any) => {
            this._ngZone.run(() => {
                if (info.companies.length > 0) {
                    this.companies = info.companies;
                    //TODO: add handling: also receives info.isFinalPage
                }
            });
        }));
        this.subscriptions.push(this._minesiteService.minesitesChange.subscribe((minesites: Minesite[]) => {
            this._ngZone.run(() => {
                for (const minesite of minesites) {
                    this.minesites.update(minesite, true);
                }
            });
        }));
        this.subscriptions.push(this._minesiteService.companyMinesiteChanges.subscribe((companyMinesites: CompanyMinesites) => {
            if (this.selectedCompanies.filter((cId) => { cId == companyMinesites.CompanyId })) {
                this._ngZone.run(() => {
                    for (const minesite of companyMinesites.Minesites) {
                        this.minesites.update(minesite, true);
                    }
                });
            }
        }));
        this.subscriptions.push(this._modelService.modelChange.subscribe((models: Model[]) => {
            this._ngZone.run(() => {
                for (const model of models) {
                    this.models.update(model, true);
                }
            });
        }));
        this.subscriptions.push(this._poweredByService.poweredBysByModelChange.subscribe((modelPoweredBys: PoweredBysByModel) => {
            if (this.selectedModelId == modelPoweredBys.ModelId) {
                this._ngZone.run(() => {
                    this.poweredBys = modelPoweredBys.PoweredBys;
                });
            }
        }));
        this.subscriptions.push(this._equipmentService.equipmentForPoweredByAndModelChange.subscribe((equipmentForMPB: EquipmentForModelAndPoweredBy) => {
            if (this.selectedModelId == equipmentForMPB.ModelId && this.selectedPoweredByIds.findIndex((value) => value == equipmentForMPB.PoweredById) > -1) {
                this._ngZone.run(() => {
                    for (const equipment of equipmentForMPB.Equipment) {
                        this.equipment.update(equipment, true);
                    }
                });
            }
        }));
        this.subscriptions.push(this._userService.permissionChange.subscribe((info: any) => {
            this._ngZone.run(() => {
                this.permissions = info;
            });
        }));

        this.prepEquipmentUrl();
        this.prepUserUrl();
    }

    public updateMinesites(): void {
        if (this.selectedCompanies.length > 0) {
            this.minesites.init();
            for (const companyId of this.selectedCompanies) {
                this._minesiteService.getMinesitesForCompany(companyId);
            }
        }
        else {
            this.minesites.init();
            this._minesiteService.getMinesites();
        }

        this.prepEquipmentUrl();
    }

    public prepEquipmentUrl(): void {
        this.equipmentReportUlr = this.rawEquipmentUrl + '?'
        if (this.selectedCompanies.length > 0) {
            for (const companyId of this.selectedCompanies) {
                this.equipmentReportUlr = this.equipmentReportUlr + 'companyIds=' + companyId + '&';
            }
        }

        if (this.selectedMinesites.length > 0) {
            for (const minesiteId of this.selectedMinesites) {
                this.equipmentReportUlr = this.equipmentReportUlr + 'minesiteIds=' + minesiteId + '&';
            }
        }
    }

    public prepUserUrl(): void {
        this.userReportUrl = this.rawUserUrl + '?'
        if (this.selectedPermissionIds.length > 0) {
            for (const permissionId of this.selectedPermissionIds) {
                this.userReportUrl = this.userReportUrl + 'permissionIds=' + permissionId + '&';
            }
        }
    }

    public updateModel(): void {
        this.selectedEquipmentIds = [];
        this.selectedPoweredByIds = [];
        this._poweredByService.getPoweredBysByModel(this.selectedModelId);
        this.updateEquipmentIds();
    }

    public updatePoweredBys(): void {
        this.selectedEquipmentIds = [];
        if (this.selectedPoweredByIds.length > 0) {
            this.equipment.init();
            for (const poweredById of this.selectedPoweredByIds) {
                this._equipmentService.getEquipmentForModelAndPoweredBy(this.selectedModelId, poweredById);

            }
        }
        this.updateEquipmentIds();
    }

    public updateEquipmentIds(): void {
        this.manualsReportUlr = this.rawManualsUrl + '?modelId=' + this.selectedModelId;
        if (this.selectedPoweredByIds.length > 0) {
            for (const poweredById of this.selectedPoweredByIds) {
                this.manualsReportUlr = this.manualsReportUlr + '&poweredByIds=' + poweredById;
            }
        }
        if (this.selectedEquipmentIds.length > 0) {
            for (const equipmentId of this.selectedEquipmentIds) {
                this.manualsReportUlr = this.manualsReportUlr + '&equipmentIds=' + equipmentId;
            }
        }
    }

    ngOnInit(): void {
        this._companyService.getCompanies();
        this._minesiteService.getMinesites();
        this._modelService.getModels();
        this._userService.getPermissions();
    }

    ngOnDestroy(): void {
        for (const subscription of this.subscriptions) {
            subscription.unsubscribe();
        }
    }
    //public isInRole(component: string): boolean {
    //    return this._authorizationService.hasRole(component);
    //}
}
